import React from 'react';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { ModalModifiersCategory } from './ModalModifiersCategory';
import Loading from '../../components/Loading';

export const ModifierCategoriesModal = ({ visible, onClose, onSave, modifiers, localModifiers, loading, setLocalModifiers }) => {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={visible}
            onRequestClose={onClose}
            closeTimeoutMS={200}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
            className="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full sm:max-w-2xl sm:mx-auto"
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(107, 114, 128, 0.75)',
                },
                content: { overflow: 'hidden' },
            }}
        >
            <Loading loading={loading}>
                <div className="px-12 pt-10">
                    <div className="font-bold text-xl mb-5">{localModifiers?.modifier_groups?.length ? t('Edit Modifiers') : t('Select Modifiers')}</div>

                    <div className="bg-white h-56 overflow-y-auto">
                        {modifiers.map((item) => {
                                return (
                                    <div key={item.id}>
                                        <ModalModifiersCategory category={item} localModifiers={localModifiers} setLocalModifiers={setLocalModifiers} />
                                    </div>
                                );
                            })}
                    </div>
                </div>

                <div className="py-5 px-12 text-right">
                    <button type="button" className="inline-flex justify-center mr-2 py-2 px-7 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-300 hover:bg-gray-400 activ:bg-gray-500 focus:outline-none" onClick={onClose}>
                        {t('Cancel')}
                    </button>
                    <button onClick={onSave} type="button" className="inline-flex justify-center py-2 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none">
                        {t('Save')}
                    </button>
                </div>
            </Loading>
        </Modal>
    );
};
